import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { UserDataLayout } from '@/features/users/components/User'
import { UserRoot } from '../user'
import { Users } from '../users'

export const UsersRoot = () => {
  return (
    <Routes>
      <Route index element={<Users />} />

      <Route element={<UserDataLayout />}>
        <Route path={':id/*'} element={<UserRoot />} />
      </Route>

      <Route path={'*'} element={<Navigate to={'/'} replace={true} />} />
    </Routes>
  )
}
